export default {
    namespaced: true,
    mutations: {
        SuggestDeposit() {},
    },
};
